/* Geeká Taller v1 — JS comum (pequeno, sem dependências).
   1) pesquisa: abre o <dialog> e pede sugestões à Predictive Search API (Section Rendering: secção taller-predictiva)
   2) filtros da coleção: aplica ao mudar (o formulário funciona sem JS com o botão «Aplicar») */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // 1) pesquisa
  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-busca-abrir]');
    if (abrir) {
      var d = document.getElementById('Busca');
      if (d && d.showModal) { e.preventDefault(); d.showModal(); var i = d.querySelector('input[type="search"]'); if (i) i.focus(); }
      return;
    }
    if (e.target.closest('[data-busca-fechar]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); }
  });

  function preditiva(form) {
    var input = form.querySelector('input[type="search"]'), alvo = form.parentElement.querySelector('[data-pred]');
    if (!input || !alvo) return;
    var t, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { alvo.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = raiz + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=taller-predictiva';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html'), s = doc.querySelector('#shopify-section-taller-predictiva');
            alvo.innerHTML = s ? s.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }
  document.querySelectorAll('form[data-busca]').forEach(preditiva);

  // 2) filtros
  document.querySelectorAll('form[data-filtros]').forEach(function (f) {
    f.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;   // preço: espera pelo «Aplicar»
      f.requestSubmit ? f.requestSubmit() : f.submit();
    });
    // fecha os outros desdobráveis ao abrir um
    f.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) f.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; }); });
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('form[data-filtros] details[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
})();
